import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { injectIntl, defineMessages } from 'react-intl'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { roles } from '../../common/config'
import { PageHeader } from '../components'

const CreateLessonPage = ({ viewer, intl }) => (
  <div className="create-lesson-page">
    <PageHeader title={intl.formatMessage(messages.title)} />
    <div className="create-lessons-links flex-row-spacing">
      <Link to="/app/create-options">
        <img src="/assets/icons/OPTIONS2.png" alt="Options" />
        <h3>{intl.formatMessage(messages.optionsexercise)}</h3>
      </Link>
      <Link to="/app/create-wordbox">
        <img src="/assets/icons/WORDBOX2.png" alt="Fill" />
        <h3>{intl.formatMessage(messages.wordboxexercise)}</h3>
      </Link>
      <Link to="/app/create-translation">
        <img src="/assets/icons/TRANSLATION2.png" alt="Translations" />
        <h3>{intl.formatMessage(messages.translateexercise)}</h3>
      </Link>
    </div>
    {
      viewer.role === roles.TEACHER &&
      <div>
        <Link className="create-test-link" to="/app/create-test">
          <h3>{intl.formatMessage(messages.createTest)}</h3>
        </Link>
        <Link className="create-test-link" to="/app/create-group">
          <h3>{intl.formatMessage(messages.createClass)}</h3>
        </Link>
      </div>
    }
  </div>
)

CreateLessonPage.propTypes = {
  intl: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
}

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
  }), { }),
  injectIntl,
)

export default enhance(CreateLessonPage)

const messages = defineMessages({
  title: {
    id: 'createLesson.page.title',
    defaultMessage: 'Vytvoriť cvičenie',
  },
  translateexercise: {
    id: 'createLesson.page.translateexercise',
    defaultMessage: 'Cvičenie na preklad výrazov',
  },
  wordboxexercise: {
    id: 'createLesson.page.wordboxexercise',
    defaultMessage: 'Cvičenie na doplňovanie slov do viet',
  },
  optionsexercise: {
    id: 'createLesson.page.optionsexercise',
    defaultMessage: 'Cvičenie na výber možností',
  },
  createTest: {
    id: 'createLesson.page.createTest',
    defaultMessage: 'Vytvoriť test',
  },
  createClass: {
    id: 'createLesson.page.createClass',
    defaultMessage: 'Vytvoriť triedu',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/CreateLessonPage.js